import React, { useEffect, useState, useContext } from 'react';
import { Link, useLocation } from "react-router-dom";
import SessionContext from "SessionContext";
import ProgressLoader from '../partials/progress-loader';
import FormatDateTime from "core/utils/FormatDateTime";

function OrderStatus() {
  const location = useLocation();
  const session = useContext(SessionContext);
  const access = session.appState.userCan;

  const {id} = location.state;
  const [orderInfo, setOrderInfo] = useState();
  const [orderLogs, setOrderLogs] = useState([]);
  const [orderErrors, setOrderErrors] = useState("");
  const [sortedDown, setSortedDown] = useState(false);

  useEffect(() => {
    if (id) {
      session.query("order/get", { id: id })
             .then((response) => {
               setOrderInfo(response);
             })
             .catch ((error) => {
               console.log("/order/get failed. ", error);
             });

      session.query("order/getlog", { id: id })
              .then((response) => {
                if(response.id !== null) {
                  setOrderLogs(response.logs.reverse());
                  setOrderErrors(response.error_text);
                }
              })
              .catch ((error) => {
                console.log("/getlog failed. ", error);
              });
    }
    // eslint-disable-next-line
  }, [id])

  const onHandleSort = () => {
    const sorted = [...orderLogs];
    setOrderLogs(sorted.reverse());
    setSortedDown(!sortedDown);
  }
 
  return (
    <div className="page">
      <div className="list-header sticky-page-header">
        <Link to="/orders">
          <button type="button" className="new-button">
            <i className="bi bi-chevron-left"></i> Orders
          </button>
        </Link>
        <h1>Order Status</h1>
        <i className="spacer" />
      </div>

      {orderInfo ? (
        <section className="order-status-main">
          <div className="status-header">
            <h5>Order Name: <span>{orderInfo.name}</span></h5>
            <h5>Order Status: <span>{orderInfo.status}</span></h5>
          </div>
          <div className="status-body">
            <div className="flex-status-col">
              <div className="history">
                <h6>Order History</h6>
                <button className="sort-btn" onClick={onHandleSort}>
                  {sortedDown ? <i className="bi bi-sort-down" /> : <i className="bi bi-sort-up-alt" />}
                </button>
              </div>

              {orderLogs && orderLogs.length ? 
                <div className="status-list" key={orderLogs}>
                  {orderLogs.map((log) => <StatusLogs log={log} key={log.message} />)}
                </div>
              : <div>No history found.</div>}
            </div>

            <div className="flex-error-col">
              <h6>Order Errors</h6><br />
              {
                orderErrors && orderErrors.length ? 
                <StatusError error={orderErrors} access={access} id={id} /> : 
                <div>No errors found.</div>
              }
            </div>
          </div>
        </section>
        ) : <StatusLoading />
      }
      
    </div>
  )
}

export default OrderStatus;

const StatusLogs = ({ log }) => {
  return (
    <div className="status-card">
      <div>
        <FormatDateTime date={log.datetime} />
        <span>: </span>
        <span>
          <b>{log.message}</b>
        </span>
      </div>
    </div>
  );
};

/**
 * @returns the raw error for admins, or a message with an email link for all others
 */
const StatusError = ({error, access, id}) => {
  return (
    <div className="error-card">
      {access('administration') ? error : 
      <span>There was an error processing your order. Please reach out to Customer Success at <a href={`mailto:audiencemaker@speedeondata.com?subject=Order # ${id}`} rel="noreferrer">audiencemaker@speedeondata.com</a> for assistance.</span>}
    </div>
  );
};

const StatusLoading = () => {
  return (
    <section className="order-status-main">
      <div className="status-loading">
        <div className="loader-wrapper"><ProgressLoader /></div>
        <div className="text-wrapper">Loading...</div>
      </div>
    </section>
  );
};
